
const labelsDefault = {
    name: {label: "name", required: true},
    devices: {label: "devices", required: true}
}

export default labelsDefault